import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup, Form } from 'react-bootstrap';

import { SearchIcon } from 'utils/icons';
import './styles.scss';

const BudgetSearchInput = React.forwardRef(
  ({ placeholder, handleClearSearch, searchVal, ...rest }, ref) => {
    return (
      <InputGroup className="budget-search-input-wrapper">
        <InputGroup.Text className="search-icon">
          <SearchIcon />
        </InputGroup.Text>
        <Form.Control
          aria-label={placeholder}
          className="search-input"
          placeholder={placeholder}
          ref={ref}
          value={searchVal}
          {...rest}
        />
        {searchVal && (
          <button
            aria-label="Clear search"
            className="budget-search-clear-button"
            onClick={handleClearSearch}
            onMouseDown={event => event.preventDefault()}
            type="button"
          />
        )}
      </InputGroup>
    );
  }
);

BudgetSearchInput.displayName = 'BudgetSearchInput';

BudgetSearchInput.propTypes = {
  placeholder: PropTypes.string,
  handleClearSearch: PropTypes.func,
  searchVal: PropTypes.string,
};

BudgetSearchInput.defaultProps = {
  placeholder: 'Search budgets...',
  handleClearSearch: () => null,
  searchVal: '',
};

export default BudgetSearchInput;
